import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Ho, kiel mi atendis lin!
    </p>

    <p class="mb-3">
      Ekde infanaĝo mi revis pri bela geedziĝo, brila juna viro, kiu de unua rigardo ekamos min, sin ĵetos al miaj kruroj, verve adoros…
    </p>

    <p class="mb-3">
      Kaj jen venis tiu momento. 
      Aperis LI, destinita ĝuste por mi, unusola en la mondo. 
      Mi tuj eksentis, ke jen LI venis! 
      Niaj okuloj renkontiĝis – kaj kvazaŭ fulmo traflugis inter ni. 
      Ni ĵetis nin unu al la alia…
    </p>
    
    <p class="mb-5">
      En firma brakumo kuniĝis niaj korpoj. 
      Kaj ju pli ni interplektiĝis, des pli forte mi ardis. 
      Jen, jen proksimiĝas la kulmino! 
      Kaj en ama ekstazo mi profunde enigis miajn mandiblojn en lian tremiĝantan korpon. 
      Kia dolĉa estis lia limfo, kia delica karno! 
      Do jen ĝi, pinto de geedziĝo, la plena feliĉo de la vivo! 
      Fin-fine mi eksentis ĝin!
    </p>

    <p class="mb-3">
      Kaj feliĉa kaj sata manto ekiris for.
    </p>
    `
  )
}

const itemName = {
  esp: 'Feliĉo de geedziĝo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;